import { Navigate } from "react-router-dom";
import { useOnboardingValidation } from "../../hooks/useOnboardingValidation";
import { useAuth } from "../../contexts/AuthContext";
import { Icon } from "@iconify/react";
import { useLocalePath } from "../../hooks/useLocalePath";

/**
 * Component that redirects users who have completed onboarding
 * If onboarding is complete, redirects to dashboard
 * If onboarding is incomplete, allows access to onboarding pages
 *
 * @param {ReactNode} children - Components to render if onboarding is incomplete
 */
const OnboardingRouteGuard = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const { isComplete } = useOnboardingValidation();
  const lp = useLocalePath();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Icon icon="svg-spinners:eclipse" className="w-12 h-12 text-primary" />
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to={lp("/login")} replace />;
  }

  // If onboarding is complete, redirect to dashboard
  if (isComplete) {
    const dashboardPath =
      user?.role === "business" ? lp("/dashboard") : lp("/client/dashboard");
    return <Navigate to={dashboardPath} replace />;
  }

  // Onboarding is incomplete, allow access to onboarding pages
  return children;
};

export default OnboardingRouteGuard;
